// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataset-customized-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  width: 100%;
}

/* 信息徽章 */
.info-badge {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 4px;
}

.badge-samples {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 10px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
}

.dataset-customized-content .dataset-info {
  width: 100%;
}

.dataset-customized-content .dataset-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

.dataset-customized-content .dataset-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 8px;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  background: #f8fafc;
}

.dataset-customized-content .dataset-info-item span {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.dataset-customized-content .dataset-info-item strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

/* 信息区域 (用于 delete-redundant 和 delete-samples) */
.info-section {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  width: 100%;
  margin-bottom: 8px;
}

.info-section .card-text {
  margin: 0;
  text-align: left;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
}

.data-processing-button-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: stretch;
  padding: 8px 0;
}

.data-processing-button-group .btn {
  width: 100%;
  min-width: 0;
  max-width: none;
  box-sizing: border-box;
  min-height: 38px;
  border-radius: 10px !important;
  font-weight: 800 !important;
  padding: 9px 14px !important;
  font-size: 13px !important;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease !important;
  margin: 0 !important;
}

.data-processing-button-group .btn-outline-secondary {
  background-color: white !important;
  color: #334155 !important;
  border: 1px solid #dbe3ef !important;
}

.data-processing-button-group .btn-outline-secondary:hover {
  background-color: #eff6ff !important;
  color: #1d4ed8 !important;
  border-color: #93c5fd !important;
  transform: none;
  box-shadow: none !important;
}

.input-content,
.delete-redundant-page,
.delete-samples-page,
.down-sampling-page,
.split-page,
.picker-page,
.cutter-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 8px 0;
}

.split-page .org-btn,
.picker-page .org-btn,
.cutter-page .org-btn,
.picker-input-content,
.cutter-input-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.picker-input-content .org-btn,
.cutter-input-content .org-btn,
.split-page > .org-btn {
  width: 100%;
  max-width: 200px;
  min-height: 38px;
  font-size: 13px;
}

/* 信息文本样式 */
.delete-redundant-page p,
.delete-samples-page p,
.down-sampling-page p,
.split-page p,
.picker-page p,
.cutter-page p {
  text-align: center;
  color: #6B7280;
  font-size: 14px;
  margin: 4px 0;
  line-height: 1.6;
}

/* Clear data 容器 */
.clear-data {
  width: 100%;
  margin: 8px 0;
}

.sample-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}

/* Delete redundant content 样式 */
.delete-redundant-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.delete-redundant-content label {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  text-align: center;
}

/* 按钮容器 */
.top-button,
.down-button {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 8px 0;
}

/* 统一样式的输入框 */
.split-page input,
.picker-page input,
.cutter-page input,
.delete-samples-page input,
.down-sampling-page input,
.delete-redundant-page input,
.delete-redundant-content input,
.target-dataset-name {
  width: 100%;
  max-width: 200px;
  padding: 10px 12px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  transition: all 0.3s ease;
  text-align: center;
  margin: 4px 0;
}

.split-page input:focus,
.picker-page input:focus,
.cutter-page input:focus,
.delete-samples-page input:focus,
.down-sampling-page input:focus,
.delete-redundant-page input:focus,
.delete-redundant-content input:focus,
.target-dataset-name:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.split-page input:hover,
.picker-page input:hover,
.cutter-page input:hover,
.delete-samples-page input:hover,
.down-sampling-page input:hover,
.delete-redundant-page input:hover,
.delete-redundant-content input:hover,
.target-dataset-name:hover {
  border-color: #3B82F6;
}

.split-page input::placeholder,
.picker-page input::placeholder,
.cutter-page input::placeholder,
.delete-samples-page input::placeholder,
.down-sampling-page input::placeholder,
.delete-redundant-page input::placeholder,
.delete-redundant-content input::placeholder {
  color: #9CA3AF;
}

/* Sample rate input 特殊布局 */
.sample-rate-input {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  padding: 0;
  border: none;
  background: transparent;
}

.sample-rate-input label {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0;
}

.sample-rate-input input {
  max-width: 120px;
  flex-shrink: 0;
  padding: 10px 12px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  transition: all 0.3s ease;
  text-align: center;
}

.sample-rate-input input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.sample-rate-input input:hover {
  border-color: #3B82F6;
}

.Button {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.target-dataset-name {
  margin-bottom: 1rem;
}

.dataset-shell {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.dataset-sidebar {
  position: sticky;
  top: 18px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 116px);
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #ffffff;
}

.dataset-sidebar-section + .dataset-sidebar-section,
.dataset-sidebar-groups {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #eef2f7;
}

.dataset-sidebar-title {
  margin: 0 0 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.dataset-sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 38px;
  margin-bottom: 6px;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  cursor: default;
}

.dataset-sidebar-item.clickable {
  cursor: pointer;
}

.dataset-sidebar-item.clickable:hover {
  background: #f8fafc;
}

.dataset-sidebar-item.active {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.dataset-sidebar-item.muted {
  color: #64748b;
  font-weight: 600;
}

.dataset-sidebar-icon,
.dataset-sidebar-star,
.dataset-sidebar-group {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  background: #dbeafe;
}

.dataset-sidebar-star,
.dataset-sidebar-group {
  border-radius: 50%;
  background: #fef3c7;
}

.dataset-sidebar-group {
  background: #ddd6fe;
}

.dataset-sidebar-footer {
  margin-top: auto;
}

.dataset-sidebar-storage {
  padding-top: 18px;
  border-top: 1px solid #eef2f7;
}

.dataset-sidebar-storage-head {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.dataset-sidebar-storage-head strong {
  color: #0f172a;
  font-size: 13px;
}

.dataset-sidebar-storage-track {
  height: 8px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.dataset-sidebar-storage-fill {
  display: block;
  width: 28%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2563eb, #60a5fa);
}

.dataset-sidebar-settings {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  min-height: 40px;
  margin-top: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  color: #334155;
  font-size: 15px;
  cursor: pointer;
}

.dataset-page {
  min-width: 0;
  padding: 0 0 40px;
}

.dataset-customized-content {
  align-items: stretch;
  padding: 8px 0 0;
}

.dataset-customized-content .card-text {
  text-align: left;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.dataset-customized-content .org-btn {
  width: 100%;
  min-height: 38px;
  margin: 0;
  font-size: 13px;
}

.annotation-page-header {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 16px;
  padding: 20px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

.annotation-page-eyebrow {
  color: #2563eb;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.annotation-page-header h1 {
  margin: 4px 0 6px;
  color: #0f172a;
  font-size: 28px;
  font-weight: 800;
}

.annotation-page-header p {
  max-width: 680px;
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.annotation-step-strip,
.annotation-page-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(96px, 1fr));
  gap: 10px;
  min-width: 420px;
}

.annotation-step-strip span,
.annotation-page-stats div {
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
  text-align: center;
}

.annotation-page-stats span {
  display: block;
  color: #64748b;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.annotation-page-stats strong {
  display: block;
  margin-top: 4px;
  color: #0f172a;
  font-size: 22px;
  line-height: 1;
}

@media (max-width: 1180px) {
  .dataset-shell,
  html[data-daat-density="compact"] .dataset-shell {
    grid-template-columns: 1fr;
  }

  .dataset-sidebar {
    position: static;
    min-height: auto;
  }

  .annotation-page-header {
    flex-direction: column;
  }

  .annotation-step-strip,
  .annotation-page-stats {
    min-width: 0;
  }

  .dataset-sidebar-section {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .dataset-sidebar-groups {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }

  .dataset-sidebar-groups .dataset-sidebar-title {
    width: 100%;
  }

  .dataset-sidebar-item {
    width: auto;
    margin: 0;
  }

  .dataset-sidebar-footer {
    display: none;
  }
}

.folder-table-dataset-tips {
  width: 100%;
  margin-top: 8px;
  padding: 14px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #f8fafc;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.delete-redundant-page,
.delete-samples-page,
.down-sampling-page,
.stable-diffusion-page,
.anomaly-synthesis-page,
.text-to-image-page {
  align-items: stretch;
}

.delete-redundant-page .btn,
.delete-samples-page .btn,
.down-sampling-page .btn,
.stable-diffusion-page .btn,
.anomaly-synthesis-page .btn {
  width: 100%;
  min-height: 40px;
  border-radius: 10px !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.delete-redundant-page .btn-outline-danger,
.delete-samples-page .btn-outline-danger,
.down-sampling-page .btn-outline-danger {
  border: 1px solid #fecdd3 !important;
  background: #fff1f2 !important;
  color: #be123c !important;
}

.delete-redundant-page .btn-outline-danger:hover,
.delete-samples-page .btn-outline-danger:hover,
.down-sampling-page .btn-outline-danger:hover {
  background: #ffe4e6 !important;
}

.stable-diffusion-page .btn-outline-primary,
.anomaly-synthesis-page .btn-outline-primary {
  border: 1px solid #2563eb !important;
  background: #2563eb !important;
  color: #ffffff !important;
}

.stable-diffusion-page .form-label,
.anomaly-synthesis-page .form-label {
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}

.stable-diffusion-page .form-control,
.anomaly-synthesis-page .form-control {
  min-height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  color: #0f172a;
  font-size: 14px;
}

.stable-diffusion-page .form-control:focus,
.anomaly-synthesis-page .form-control:focus {
  border-color: #2563eb !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
}

.sd-params-row,
.anomaly-params-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  align-items: end;
  margin-bottom: 12px;
}

.anomaly-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.anomaly-toggle-title {
  margin: 0;
  color: #1f2937;
  font-size: 14px;
  font-weight: 700;
}

.anomaly-toggle-desc {
  margin: 2px 0 0;
  color: #6b7280;
  font-size: 13px;
}

.anomaly-switch {
  position: relative;
  flex-shrink: 0;
  width: 42px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: #d8dee9;
  cursor: pointer;
  transition: background 180ms ease;
}

.anomaly-switch.on {
  background: #93b4f5;
}

.anomaly-switch-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: left 180ms ease;
}

.anomaly-switch.on .anomaly-switch-knob {
  left: 20px;
}

.sd-preview-grid,
.anomaly-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.sd-preview-grid img,
.anomaly-preview-grid img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

@media (max-width: 768px) {
  .annotation-step-strip,
  .annotation-page-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .annotation-page-header,
  .annotation-toolbar {
    padding: 16px;
  }

  .annotation-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .sd-params-row,
  .anomaly-params-row {
    grid-template-columns: 1fr;
  }
}

.tti-error-box {
  margin-top: 12px;
  padding: 12px 16px;
  background: #fff5f5;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #b91c1c;
  font-size: 13px;
  word-break: break-all;
}

.tti-error-box pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: inherit;
}

.tti-model-badge {
  display: inline-flex;
  margin-bottom: 14px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.tti-source-section {
  margin-bottom: 16px;
}

.tti-source-section > .form-label {
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}

.tti-source-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  max-height: 250px;
  overflow-y: auto;
}

.tti-source-item {
  min-width: 0;
  padding: 4px;
  border: 2px solid transparent;
  border-radius: 10px;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
}

.tti-source-item:hover {
  background: #f1f5f9;
}

.tti-source-item.selected {
  border-color: #111827;
  background: #fff;
}

.tti-source-item img {
  display: block;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 6px;
}

.tti-source-item span {
  display: block;
  padding: 5px 2px 1px;
  overflow: hidden;
  font-size: 11px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tti-source-empty {
  padding: 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/DatasetPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,6FAA6F;EAC7F,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;;;;;;EAOE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;;;;;;EAME,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;;EAEE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA,aAAa;AACb;;;;;;;;EAQE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;;;;;EAQE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;;;;;;EAQE,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;;;;EAKE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;;EAGE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,gDAAgD;EAClD;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".dataset-customized-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  width: 100%;\n}\n\n/* 信息徽章 */\n.info-badge {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  width: 100%;\n  margin-bottom: 4px;\n}\n\n.badge-samples {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 4px 10px;\n  border: 1px solid #dbeafe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.dataset-customized-content .dataset-info {\n  width: 100%;\n}\n\n.dataset-customized-content .dataset-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.dataset-customized-content .dataset-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 8px;\n  border: 1px solid #eef2f7;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.dataset-customized-content .dataset-info-item span {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.dataset-customized-content .dataset-info-item strong {\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n/* 信息区域 (用于 delete-redundant 和 delete-samples) */\n.info-section {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 4px;\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.info-section .card-text {\n  margin: 0;\n  text-align: left;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.5;\n}\n\n.data-processing-button-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  align-items: stretch;\n  padding: 8px 0;\n}\n\n.data-processing-button-group .btn {\n  width: 100%;\n  min-width: 0;\n  max-width: none;\n  box-sizing: border-box;\n  min-height: 38px;\n  border-radius: 10px !important;\n  font-weight: 800 !important;\n  padding: 9px 14px !important;\n  font-size: 13px !important;\n  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease !important;\n  margin: 0 !important;\n}\n\n.data-processing-button-group .btn-outline-secondary {\n  background-color: white !important;\n  color: #334155 !important;\n  border: 1px solid #dbe3ef !important;\n}\n\n.data-processing-button-group .btn-outline-secondary:hover {\n  background-color: #eff6ff !important;\n  color: #1d4ed8 !important;\n  border-color: #93c5fd !important;\n  transform: none;\n  box-shadow: none !important;\n}\n\n.input-content,\n.delete-redundant-page,\n.delete-samples-page,\n.down-sampling-page,\n.split-page,\n.picker-page,\n.cutter-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.split-page .org-btn,\n.picker-page .org-btn,\n.cutter-page .org-btn,\n.picker-input-content,\n.cutter-input-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.picker-input-content .org-btn,\n.cutter-input-content .org-btn,\n.split-page > .org-btn {\n  width: 100%;\n  max-width: 200px;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n/* 信息文本样式 */\n.delete-redundant-page p,\n.delete-samples-page p,\n.down-sampling-page p,\n.split-page p,\n.picker-page p,\n.cutter-page p {\n  text-align: center;\n  color: #6B7280;\n  font-size: 14px;\n  margin: 4px 0;\n  line-height: 1.6;\n}\n\n/* Clear data 容器 */\n.clear-data {\n  width: 100%;\n  margin: 8px 0;\n}\n\n.sample-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n}\n\n/* Delete redundant content 样式 */\n.delete-redundant-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.delete-redundant-content label {\n  font-size: 14px;\n  color: #374151;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* 按钮容器 */\n.top-button,\n.down-button {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin: 8px 0;\n}\n\n/* 统一样式的输入框 */\n.split-page input,\n.picker-page input,\n.cutter-page input,\n.delete-samples-page input,\n.down-sampling-page input,\n.delete-redundant-page input,\n.delete-redundant-content input,\n.target-dataset-name {\n  width: 100%;\n  max-width: 200px;\n  padding: 10px 12px;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  transition: all 0.3s ease;\n  text-align: center;\n  margin: 4px 0;\n}\n\n.split-page input:focus,\n.picker-page input:focus,\n.cutter-page input:focus,\n.delete-samples-page input:focus,\n.down-sampling-page input:focus,\n.delete-redundant-page input:focus,\n.delete-redundant-content input:focus,\n.target-dataset-name:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.split-page input:hover,\n.picker-page input:hover,\n.cutter-page input:hover,\n.delete-samples-page input:hover,\n.down-sampling-page input:hover,\n.delete-redundant-page input:hover,\n.delete-redundant-content input:hover,\n.target-dataset-name:hover {\n  border-color: #3B82F6;\n}\n\n.split-page input::placeholder,\n.picker-page input::placeholder,\n.cutter-page input::placeholder,\n.delete-samples-page input::placeholder,\n.down-sampling-page input::placeholder,\n.delete-redundant-page input::placeholder,\n.delete-redundant-content input::placeholder {\n  color: #9CA3AF;\n}\n\n/* Sample rate input 特殊布局 */\n.sample-rate-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  justify-content: center;\n  width: 100%;\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n}\n\n.sample-rate-input label {\n  font-size: 14px;\n  color: #374151;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.sample-rate-input input {\n  max-width: 120px;\n  flex-shrink: 0;\n  padding: 10px 12px;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.sample-rate-input input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.sample-rate-input input:hover {\n  border-color: #3B82F6;\n}\n\n.Button {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.target-dataset-name {\n  margin-bottom: 1rem;\n}\n\n.dataset-shell {\n  display: grid;\n  grid-template-columns: 220px minmax(0, 1fr);\n  gap: 24px;\n  align-items: start;\n}\n\n.dataset-sidebar {\n  position: sticky;\n  top: 18px;\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 116px);\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  background: #ffffff;\n}\n\n.dataset-sidebar-section + .dataset-sidebar-section,\n.dataset-sidebar-groups {\n  margin-top: 22px;\n  padding-top: 18px;\n  border-top: 1px solid #eef2f7;\n}\n\n.dataset-sidebar-title {\n  margin: 0 0 8px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.dataset-sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 38px;\n  margin-bottom: 6px;\n  padding: 8px 10px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: transparent;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  text-align: left;\n  cursor: default;\n}\n\n.dataset-sidebar-item.clickable {\n  cursor: pointer;\n}\n\n.dataset-sidebar-item.clickable:hover {\n  background: #f8fafc;\n}\n\n.dataset-sidebar-item.active {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.dataset-sidebar-item.muted {\n  color: #64748b;\n  font-weight: 600;\n}\n\n.dataset-sidebar-icon,\n.dataset-sidebar-star,\n.dataset-sidebar-group {\n  width: 16px;\n  height: 16px;\n  border-radius: 5px;\n  background: #dbeafe;\n}\n\n.dataset-sidebar-star,\n.dataset-sidebar-group {\n  border-radius: 50%;\n  background: #fef3c7;\n}\n\n.dataset-sidebar-group {\n  background: #ddd6fe;\n}\n\n.dataset-sidebar-footer {\n  margin-top: auto;\n}\n\n.dataset-sidebar-storage {\n  padding-top: 18px;\n  border-top: 1px solid #eef2f7;\n}\n\n.dataset-sidebar-storage-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.dataset-sidebar-storage-head strong {\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.dataset-sidebar-storage-track {\n  height: 8px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.dataset-sidebar-storage-fill {\n  display: block;\n  width: 28%;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #2563eb, #60a5fa);\n}\n\n.dataset-sidebar-settings {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  min-height: 40px;\n  margin-top: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.dataset-page {\n  min-width: 0;\n  padding: 0 0 40px;\n}\n\n.dataset-customized-content {\n  align-items: stretch;\n  padding: 8px 0 0;\n}\n\n.dataset-customized-content .card-text {\n  text-align: left;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.dataset-customized-content .org-btn {\n  width: 100%;\n  min-height: 38px;\n  margin: 0;\n  font-size: 13px;\n}\n\n.annotation-page-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 16px;\n  padding: 20px 24px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n}\n\n.annotation-page-eyebrow {\n  color: #2563eb;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.annotation-page-header h1 {\n  margin: 4px 0 6px;\n  color: #0f172a;\n  font-size: 28px;\n  font-weight: 800;\n}\n\n.annotation-page-header p {\n  max-width: 680px;\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.annotation-step-strip,\n.annotation-page-stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(96px, 1fr));\n  gap: 10px;\n  min-width: 420px;\n}\n\n.annotation-step-strip span,\n.annotation-page-stats div {\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.annotation-page-stats span {\n  display: block;\n  color: #64748b;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.annotation-page-stats strong {\n  display: block;\n  margin-top: 4px;\n  color: #0f172a;\n  font-size: 22px;\n  line-height: 1;\n}\n\n@media (max-width: 1180px) {\n  .dataset-shell,\n  html[data-daat-density=\"compact\"] .dataset-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .dataset-sidebar {\n    position: static;\n    min-height: auto;\n  }\n\n  .annotation-page-header {\n    flex-direction: column;\n  }\n\n  .annotation-step-strip,\n  .annotation-page-stats {\n    min-width: 0;\n  }\n\n  .dataset-sidebar-section {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .dataset-sidebar-groups {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .dataset-sidebar-groups .dataset-sidebar-title {\n    width: 100%;\n  }\n\n  .dataset-sidebar-item {\n    width: auto;\n    margin: 0;\n  }\n\n  .dataset-sidebar-footer {\n    display: none;\n  }\n}\n\n.folder-table-dataset-tips {\n  width: 100%;\n  margin-top: 8px;\n  padding: 14px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.delete-redundant-page,\n.delete-samples-page,\n.down-sampling-page,\n.stable-diffusion-page,\n.anomaly-synthesis-page,\n.text-to-image-page {\n  align-items: stretch;\n}\n\n.delete-redundant-page .btn,\n.delete-samples-page .btn,\n.down-sampling-page .btn,\n.stable-diffusion-page .btn,\n.anomaly-synthesis-page .btn {\n  width: 100%;\n  min-height: 40px;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n}\n\n.delete-redundant-page .btn-outline-danger,\n.delete-samples-page .btn-outline-danger,\n.down-sampling-page .btn-outline-danger {\n  border: 1px solid #fecdd3 !important;\n  background: #fff1f2 !important;\n  color: #be123c !important;\n}\n\n.delete-redundant-page .btn-outline-danger:hover,\n.delete-samples-page .btn-outline-danger:hover,\n.down-sampling-page .btn-outline-danger:hover {\n  background: #ffe4e6 !important;\n}\n\n.stable-diffusion-page .btn-outline-primary,\n.anomaly-synthesis-page .btn-outline-primary {\n  border: 1px solid #2563eb !important;\n  background: #2563eb !important;\n  color: #ffffff !important;\n}\n\n.stable-diffusion-page .form-label,\n.anomaly-synthesis-page .form-label {\n  color: #334155;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.stable-diffusion-page .form-control,\n.anomaly-synthesis-page .form-control {\n  min-height: 40px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  color: #0f172a;\n  font-size: 14px;\n}\n\n.stable-diffusion-page .form-control:focus,\n.anomaly-synthesis-page .form-control:focus {\n  border-color: #2563eb !important;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;\n}\n\n.sd-params-row,\n.anomaly-params-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  align-items: end;\n  margin-bottom: 12px;\n}\n\n.anomaly-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.anomaly-toggle-title {\n  margin: 0;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.anomaly-toggle-desc {\n  margin: 2px 0 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.anomaly-switch {\n  position: relative;\n  flex-shrink: 0;\n  width: 42px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: #d8dee9;\n  cursor: pointer;\n  transition: background 180ms ease;\n}\n\n.anomaly-switch.on {\n  background: #93b4f5;\n}\n\n.anomaly-switch-knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  transition: left 180ms ease;\n}\n\n.anomaly-switch.on .anomaly-switch-knob {\n  left: 20px;\n}\n\n.sd-preview-grid,\n.anomaly-preview-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.sd-preview-grid img,\n.anomaly-preview-grid img {\n  width: 100%;\n  aspect-ratio: 1;\n  object-fit: cover;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n}\n\n@media (max-width: 768px) {\n  .annotation-step-strip,\n  .annotation-page-stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .annotation-page-header,\n  .annotation-toolbar {\n    padding: 16px;\n  }\n\n  .annotation-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .sd-params-row,\n  .anomaly-params-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.tti-error-box {\n  margin-top: 12px;\n  padding: 12px 16px;\n  background: #fff5f5;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  color: #b91c1c;\n  font-size: 13px;\n  word-break: break-all;\n}\n\n.tti-error-box pre {\n  margin: 0;\n  white-space: pre-wrap;\n  font-family: inherit;\n}\n\n.tti-model-badge {\n  display: inline-flex;\n  margin-bottom: 14px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #eef2f7;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.tti-source-section {\n  margin-bottom: 16px;\n}\n\n.tti-source-section > .form-label {\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.tti-source-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.tti-source-item {\n  min-width: 0;\n  padding: 4px;\n  border: 2px solid transparent;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #475569;\n  cursor: pointer;\n}\n\n.tti-source-item:hover {\n  background: #f1f5f9;\n}\n\n.tti-source-item.selected {\n  border-color: #111827;\n  background: #fff;\n}\n\n.tti-source-item img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 1;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.tti-source-item span {\n  display: block;\n  padding: 5px 2px 1px;\n  overflow: hidden;\n  font-size: 11px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tti-source-empty {\n  padding: 20px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 10px;\n  color: #64748b;\n  font-size: 13px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
